import React from 'react';
import VarietyProduct from '../VarietyProduct/VarietyProduct';
import './BestVarietiesProducts.css';
import Slugify from '@js/utils/Slugify';

function BestVarietiesProducts ({ params, products = [] }) {
  return (
    <section className="BestVarietiesProducts">
      <div className="BestVarietiesProducts-description">
        <h2 className="typo-brand-main-menu">
          Nos 3 variétés LG recommandées
        </h2>
        <p>
        Les 4 principaux critères pour bien choisir sa variété de tournesol sont le rendement, la précocité (adaptée à la région et à la date de semis), la tolérance aux herbicides (seulement si flore difficile et/ou orobanche) et le profil sanitaire : privilégier des variétés TPS ou PS orobanche, phomopsis, verticillium ou sclérotinia selon le risque parcellaire.
        <br /><br />
        Tenez compte également du risque mildiou de la parcelle : selon l’historique et la fréquence de retour du tournesol, choisir et alterner les meilleurs profils (ex : RM9/RM8).
        </p>
      </div>
      <div className="BestVarietiesProducts-products">
        <div className="BestVarietiesProducts-list">
          {products.slice(0,3).map((product) => (
              <VarietyProduct key={`product-${Slugify(product.id)}`} params={params} product={product} />
            ))
          }
        </div>
      </div>
    </section>
  )
}

export default BestVarietiesProducts;
